export const obfuscateEmail = (str: string) => {
  const init = str.slice(0, 2);

  return `${init}***@*****.***`;
};
